import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '@app/services/auth/auth.service';

import { environment } from '@env/environment';

@Component({
    selector: 'app-custom-error',
    templateUrl: './custom-error.component.html',
    styleUrls: ['custom-error.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomErrorComponent implements OnInit {

  message: string;

  appName = environment.app.name;
  appLogo = environment.app.logo;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,) { }

  ngOnInit() {
    this.message = this.route.snapshot.queryParams.message;
  }

  goToLogin() {
    if (this.authService.isAuthenticated()) {
      this.authService.logout()
      .subscribe(() => {
        this.router.navigate(['/login']);
      });
    } else {
      this.router.navigate(['/login']);
    }
    
  }

}
